export default {
  productDescription: {
    en: `
      Press Spacebar to reorder product in the queue.
      Press Enter to open product description modal.
      Press Delete to remove product from the queue
    `,
  },
  productSelected: {
    en: `
      Product {productTitle} selected.
      Current position in queue: {productCount} of {totalCount}.
      Shipped at {monthName} of {year}.
      Press left and right arrow keys to change position, Backspace key to delete, Escape key to cancel reorder
    `,
  },
  productMoved: {
    en: `
      Product {productTitle} moved.
      Current position in queue: {productCount} of {totalCount}.
      Shipped at {monthName} of {year}.
    `,
  },
  productDropped: {
    en: `
      Product {productTitle} dropped.
      Final position in queue: {productCount} of {totalCount}.
      Shipped at {monthName} of {year}.
    `,
  },
  productDeleted: {
    en: '{productTitle} has been deleted from the queue',
  },
  productCanceled: {
    en: 'Reorder cancelled for product {productTitle}',
  },
}
